import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const TrashSvg = () => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.8125 5.33398H12.8125V14.0007C12.8125 14.1775 12.7467 14.347 12.6294 14.4721C12.5122 14.5971 12.3533 14.6673 12.1875 14.6673H3.4375C3.27174
      14.6673 3.11277 14.5971 2.99556 14.4721C2.87835 14.347 2.8125 14.1775 2.8125 14.0007V5.33398ZM4.0625 6.66732V13.334H11.5625V6.66732H4.0625ZM5.9375
      8.00065H7.1875V12.0007H5.9375V8.00065ZM8.4375 8.00065H9.6875V12.0007H8.4375V8.00065ZM4.6875 3.33398V2.00065C4.6875 1.82384 4.75335 1.65427 4.87056
      1.52925C4.98777 1.40422 5.14674 1.33398 5.3125 1.33398H10.3125C10.4783 1.33398 10.6372 1.40422 10.7544 1.52925C10.8717 1.65427 10.9375 1.82384 10.9375
      2.00065V3.33398H14.0625V4.66732H1.5625V3.33398H4.6875ZM5.9375 2.66732V3.33398H9.6875V2.66732H5.9375Z"
      fill="CurrentColor"
    />
  </svg>
);

const Trash = (props: IIconProps) => <Icon component={TrashSvg} {...props} />;

export default Trash;
